import * as yup from "yup";
import { digitsAndWords } from "@components/forms/regexp";
import { errorMessage } from "@components/forms/error";

export const passwordChangeSchema = yup.object().shape({
  user_id: yup.string().required().trim(),
  new_password: yup
    .string()
    .min(8, (params) => errorMessage.min(params.min))
    .matches(digitsAndWords, errorMessage.digitsAndWords)
    .required(() => errorMessage.required),
});
